import { untilComplete } from "@pjs/observables";
import { revokeTemporaryAccess } from "../functions/RevokeTemporaryAccess.function";
import { TemporaryAccessState } from "../enums/TemporaryAccessState";
import { emptyTemporaryAccessDetails } from "../consts/EmptyTempAccessDetails.const";
import { temporaryAccessDetails } from "../consts/TemporaryAccessDetails.const";

export const removeTemporaryAccess = (tempAccessId: string, isTempAccessSession: boolean): void => {
    const document = temporaryAccessDetails.get();

    document.model.state.update({ descriptor: TemporaryAccessState.RevokePending });

    revokeTemporaryAccess({ tempAccessId: tempAccessId })
        .pipe(untilComplete(document.changeStream))
        .subscribe({
            next: () => {
                if (isTempAccessSession) {
                    window.location.hash = "";
                }

                document.model.details.update(emptyTemporaryAccessDetails);
                document.model.state.update({ descriptor: TemporaryAccessState.OK });
            },
            error: () => {
                document.model.state.update({ descriptor: TemporaryAccessState.RevokeFailed });
            }
        });
};
